import { Grid, GridProps } from '@mui/material';

interface ColumnProps extends React.PropsWithChildren, GridProps {}

const Column: React.FC<ColumnProps> = (props) => {
  const { children, style, sx, ...rest } = props;

  return (
    <Grid
      {...rest}
      style={{ position: 'relative', display: 'flex', flexDirection: 'column', ...style }}
      sx={sx}>
      {children}
    </Grid>
  );
};

export default Column;
